<template>
  <div>
    <div class="table">
      <div class="container">
        <div class="handle-box">
          <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="130px">
            <el-row :gutter="16">
              <el-col :span="8">
                <el-form-item label="Category1" prop="categoryLevel1Code">
                  <ic-select disabled table="BASE" filterable field="CATEGORY_LEVEL1" clearable @change="queryCondition.categoryLevel2Code=null,queryCondition.categoryLevel3Code=null" v-model="queryCondition.categoryLevel1Code"></ic-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="Category2" prop="categoryLevel2Code">
                  <ic-select table="BASE" filterable :field="queryCondition.categoryLevel1Code" clearable @change="queryCondition.categoryLevel3Code=null" v-model="queryCondition.categoryLevel2Code"></ic-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="Category3" prop="categoryLevel3code">
                  <ic-select :table="queryCondition.categoryLevel1Code" filterable :field="queryCondition.categoryLevel2Code" clearable v-model="queryCondition.categoryLevel3Code"></ic-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="8">
                <el-form-item :label="$t('base.fiveBitCode.title')" prop="fiveBitCode">
                  <el-input class="handle-input" v-model.trim="queryCondition.fiveBitCode" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="产品名称" prop="fiveBitCodeName">
                  <el-input class="handle-input" v-model="queryCondition.fiveBitCodeName" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="产品描述" prop="describe">
                  <el-input class="handle-input" v-model="queryCondition.describe" clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="8">
                <el-form-item label="模板名称" prop="templateName">
                  <el-input class="handle-input" v-model="queryCondition.templateName" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="备注" prop="remark">
                  <el-input class="handle-input" v-model.trim="queryCondition.remark" clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" justify="center">
              <el-button type="primary" @click="queryData(1)">{{$t('common.search')}}</el-button>
              <el-button type="primary" @click="restQueryForm">{{$t('common.reset')}}</el-button>
              <el-button type="primary" @click="pickUp">{{$t('common.confirm')}}</el-button>
            </el-row>
          </el-form>
        </div>
        <el-table :data="tableData" ref="pickUserTable" border highlight-current-row max-height='350'>
          <el-table-column prop="ttSensoryTemplateId " :label="$t('common.select')" width="50" align="center">
            <template slot-scope="scope">
              <el-radio v-model="radioVal" @change.native="getSelectRow(scope.row)" :label="scope.row.ttSensoryTemplateId ">&nbsp;</el-radio>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip sortable prop="categoryLevel1Name" label="Category1" min-width="120"></el-table-column>
          <el-table-column show-overflow-tooltip sortable prop="categoryLevel2Name" label="Category2" min-width="120"></el-table-column>
          <el-table-column show-overflow-tooltip sortable prop="categoryLevel3Name" label="Category3" min-width="120"></el-table-column>
          <el-table-column show-overflow-tooltip sortable prop="fiveBitCode" :label="$t('base.fiveBitCode.title')" min-width="100">
            <template slot-scope="scope">
              <el-button type="text" @click="goTo(scope.row)">{{scope.row.fiveBitCode}}</el-button>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip sortable prop="fiveBitCodeName" label="产品名称" min-width="200"></el-table-column>
          <el-table-column show-overflow-tooltip sortable prop="describe" label="产品描述" min-width="200"></el-table-column>
          <el-table-column show-overflow-tooltip sortable prop="templateName" label="模板名称" min-width="200"></el-table-column>
          <el-table-column show-overflow-tooltip sortable prop="remark" label="备注" min-width="150"></el-table-column>
          <el-table-column show-overflow-tooltip sortable prop="version" label="版本号" min-width="100"></el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import commonFun from "@/utils/commonFun";
import IcSelect from "@/components/common/icSelect";
import dataTableUtils from "@/utils/dataTableUtils";
import fiveBitCode from "@/api/base-data/fiveBitCode";

export default {
  name: "pickupFiveBitCode",
  components: { IcSelect },
  props: {
    value: String,
    title: String,
    multi: Boolean,
    placeholder: String,
    selectDatas: Array,
    disabled: Array
  },
  extends: dataTableUtils,
  data() {
    return {
      radioVal: null,
      puPlaceholder: this.placeholder,
      tableData: [],
      selectedId: this.value,
      selectDataAll: this.multi
        ? {
          defaultData: commonFun.convertToArray(this.value),
          pageDatas: []
        }
        : this.value,
      totalCount: 0,
      labelPosition: "right",
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        fiveBitCode: '',
        templateName: '',
        categoryLevel1Code: '10',
        categoryLevel2Code: '',
        categoryLevel3Code: '',
        remark: "",
        fiveBitCodeName: "",
        describe: "",
      },
      showDialog: false,
      notSelRoles: [],
      selectRows: [],
      selRoles: [],
      userId: null,
      userInfo: {},
      showUserInfo: false
    };
  },
  created() {
    this.queryData(1);
  },
  computed: {
    getSelectedData() {
      if (this.multi) {
        let selectedData = [];
        let defaultData = this.selectDataAll.defaultData;
        if (commonFun.isNotEmpty(defaultData)) {
          selectedData.push(...defaultData);
        }
        let pageDatas = this.selectDataAll.pageDatas;
        for (let pageData of pageDatas.values()) {
          if (commonFun.isNotEmpty(pageData)) {
            selectedData.push(...pageData);
          }
        }
        return selectedData;
      } else {
        return this.selectDataAll;
      }
    },
  },
  watch: {
    value(newVal) {
      console.log("🚀 ~ file: templateName.vue ~ line 137 ~ value ~ newVal", newVal)
      this.selectDataAll = this.multi ? { defaultData: commonFun.convertToArray(newVal), pageDatas: [] } : newVal;
    }
  },
  methods: {
    // GRI(产品编码)进行可跳转到物料主数据页面
    goTo(row) {
      let resolve = this.$router.resolve({
        path: `/material-master-data?fiveBitCode=${row.fiveBitCode}`
      });
      window.open(resolve.href, "_blank");
    },
    //单选操作
    getSelectRow(row) {
      console.log("🚀 ~ file: templateName.vue ~ line 152 ~ getSelectRow ~ row", row)
      this.selectRows = [];
      this.selectRows = row;
      console.log("🚀 ~ file: templateName.vue ~ line 155 ~ getSelectRow ~ this.selectRows", this.selectRows)
    },
    queryData(val) {
      var that = this;
      if (undefined != val) {
        that.queryCondition.pageNum = 1;
      }
      fiveBitCode.query(that.queryCondition).then(res => {
        console.log("🚀 ~ file: templateName.vue:183 ~ fiveBitCode.query ~ res:", res)
        that.tableData = res.data.records;
        that.totalCount = res.data.total;
      });
    },
    pickUp() {
      console.log("🚀 ~ file: templateName.vue ~ line 169 ~ pickUp ~ this.selectRows", this.selectRows)
      this.$emit("pickup", this.selectRows);
    },
    //查询条件重置方法
    restQueryForm: function () {
      this.$refs.queryCondition.resetFields();
      this.queryCondition.pageSize = 15;
      this.queryCondition.pageNum = 1;
      this.queryCondition.fiveBitCode = ''
      this.queryCondition.templateName = ''
      this.queryCondition.categoryLevel1Code = '10'
      this.queryCondition.categoryLevel2Code = ''
      this.queryCondition.categoryLevel3Code = ''
      this.queryCondition.fiveBitCodeName = ''
      this.queryCondition.describe = ''
      this.radioVal = ''
      this.queryData();
    },
  }
};
</script>
<style scoped  lang="scss">
.el-select {
  width: 100%;
}
.el-table {
  margin-top: 10px;
}
</style>
